import { constants } from 'modules/common';
import { z } from 'zod';

const { qBooksConstants } = constants;

export const schema = z.object({
    shippingTo: z.string().max(qBooksConstants.SHIPPING_ADDRESS_MAX_LENGTH),
    shipVia: z.string().max(qBooksConstants.SHIP_VIA_MAX_LENGTH),
    trackingNumber: z.string().max(qBooksConstants.TRACKING_NUMBER_MAX_LENGTH),
    shippingDate: z.string(),
    shippingFrom: z.string().max(qBooksConstants.SHIPPING_ADDRESS_MAX_LENGTH),
    shippingPrice: z.number().nullable(),
    shippingTaxCode: z.string(),
});
